module.exports = __webpack_public_path__ + "media/images/lb/120-347df046f534e0cd0bd8f44f38085994.svg";